import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewParametroContable = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'parametro_contable',
        name: 'Parametro Contable',
        component: ViewParametroContable,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
